<template>
  <div class>
    <section class="app-section filterAnalysis">
      <div class="card">
        <Form
          :model="curModule"
          :label-width="120"
          :rules="moduleRule"
          label-position="right"
          ref="ruleForm"
          style="margin-left: -40px;margin-right: 40px"
        >
          <FormItem label="分组名称" required prop="name">
            <Input v-model.trim="curModule.name" :maxlength="20" placeholder="请填写分组名称"></Input>
          </FormItem>
          <FormItem required label="权限" prop="permissions">
            <Select v-model="curModule.permissions">
              <Option value="team">团队可见</Option>
              <Option value="only">个人可见</Option>
            </Select>
          </FormItem>
          <FormItem label="团队选择" v-if="curModule.permissions == 'team'" prop="team_ids">
            <Select v-model="curModule.team_ids" multiple>
              <Option :value="i.team_id" v-for="(i) in teamList" :key="i.team_id">{{i.team_name}}</Option>
            </Select>
          </FormItem>
          <FormItem label="排序" required prop="sort">
            <Input
              v-model.trim="curModule.sort"
              @on-keyup="proving1($event)"
              type="number"
              placeholder="请输入排序"
            ></Input>
          </FormItem>
          <FormItem required label="是否可见" prop="invisible">
            <Select v-model="curModule.invisible">
              <Option value="0">是</Option>
              <Option value="1">否</Option>
            </Select>
          </FormItem>
          <!-- <FormItem label="颜色配置" prop="color">
            <el-input type="color" autosize placeholder="请输入内容" v-model="curModule.color"></el-input>
          </FormItem>-->
          <FormItem label="颜色配置" class="colorpz" prop="color">
            <color-select :color-list="colorList" v-model="curModule.color"></color-select>
          </FormItem>
        </Form>
      </div>

      <div class="card" style="margin-top:15px">
        <div class="patient-analysis">
          <div class="left">
            <div
              class="out-container"
              :class="{ 'out-container-line': list.length > 2 && index !== list.length-1 ,
          'out-container__active': activeItem === index,
          'out-container__short': list.length < 3
           }"
              v-for="(i, index) in list"
              :key="index"
              @click="handleItem(i, index)"
            >
              <div class="out-container-cover" v-if="index === list.length - 2"></div>

              <div class="out-relationship-select" v-if="index !== list.length - 2">
                <Select v-model="i.associatOperator" style="width: 60px">
                  <Option
                    v-for="it in relationships"
                    :value="it.value"
                    :key="it.value"
                  >{{ it.label }}</Option>
                </Select>
              </div>
              <div
                :class="{
            'out-container-context':activeItem === index
          }"
                class="out-container-body"
              >
                <span v-if="!i.hasOwnProperty('questionId') && index != 0" class="add-item">+新增问卷条件</span>
                <span v-else class="out-container-title">
                  <span>{{ i.name || '未命名'}}</span>

                  <i class="el-icon-delete" @click.stop="onDelete(index)" style="margin-left:20px"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="right">
            <condition-filter
              :childList="childList"
              :edit="edit"
              :category_id="category_id"
              @childData="childData"
            />
          </div>
        </div>

        <div style="padding-left:200px;margin:20px 0">
          <Button type="primary" round @click="saveRule('ruleForm')">保存为入组条件</Button>
          <Button style="margin:0 20px" round @click="reset()">重置</Button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { addGroup } from '../../api/group'
import route from '../../route/config'

import ConditionFilter from './components/ConditionFilter.vue'
import colorSelect from './components/colorSelect'
export default {
  name: 'filterAnalysis',
  props: ['info'],
  data() {
    return {
      //颜色初始数据
      colorList: [
        '#c17dfb',
        '#529ff5',
        '#39bc64',
        '#fa7070',
        '#f5b10d',
        '#2fb778',
        '#6e84f3',
        '#fea100',
      ],
      activeItem: 0,
      list: [
        {
          questionId: '',
          name: '',
          moduleIndex: 0,
          questions: [],
          associatOperator: '与',
          moduleQueryList: [
            {
              associatOperator: '或',
              conditionList: [
                {
                  associatOperator: '或',
                  conditionContent: '',
                  conditionIndex: 0,
                  operator: '',
                  subjectId: '',
                },
              ],
              moduleIndex: 0,
            },
          ],
        },
        {
          name: '',
        },
      ],
      associatOperator: '与',
      relationships: [
        {
          label: '或',
          value: '或',
        },
        {
          label: '与',
          value: '与',
        },
      ],
      category_id: '3',
      childList: [],
      edit: false,
      curModule: {
        name: '',
        permissions: 'team',
        team_ids: this.$store.state.shift.team_id,
        sort: '',
        invisible: '1',
        color: '#c17dfb',
      },
      moduleRule: {
        name: [
          {
            required: true,
            message: '请填写分组名称',
            trigger: 'blur',
          },
        ],
        permissions: [
          {
            required: true,
            message: '请选择权限',
            trigger: 'change',
          },
        ],
        team_ids: [
          {
            required: true,
            message: '请选择团队',
          },
        ],
        invisible: [
          {
            required: true,
            message: '请选择',
            trigger: 'change',
          },
        ],
        sort: [
          {
            required: true,
            message: '请输入排序',
            // trigger: 'blur',
          },
        ],
      },
      type: '1',
      template: null,
      teamList: [],
    }
  },
  computed: {},
  components: {
    ConditionFilter,
    colorSelect,
  },
  methods: {
    proving1(e) {
      var str = e.target.value
      var len1 = str.substr(0, 1)
      var len2 = str.substr(1, 1)
      var keynum = window.event ? e.keyCode : e.which //获取键盘码
      if (keynum == 189 || keynum == 190 || keynum == 109 || keynum == 69) {
        e.target.value = ' '
      }
      if (str.length > 1 && len1 == 0 && len2 != '.') {
        e.target.value = str.substr(1, 1)
      }
    },
    refesh() {
      const list = this.$store.state.allSelectedKeys.map((l) => {
        if (l.key === 'confirmedGroup') {
          l.refesh = true
        }
        return l
      })
      this.$store.commit('setAllSelectedKeys', {
        type: 'allAdd',
        list,
      })
      setTimeout(() => {
        const list = this.$store.state.allSelectedKeys.map((l) => {
          if (l.key === 'confirmedGroup') {
            l.refesh = false
          }
          return l
        })
        this.$store.commit('setAllSelectedKeys', {
          type: 'allAdd',
          list,
        })
      }, 400)
    },
    handleItem(i, index) {
      console.log(i, '新增条件', index)
      this.activeItem = index
      if (index === this.list.length - 1) {
        this.list.splice(this.list.length - 1, 0, {
          questionId: '',
          name: '',
          questions: [],
          moduleIndex: index,
          associatOperator: '与',
          moduleQueryList: [
            {
              associatOperator: '或',
              conditionList: [
                {
                  associatOperator: '或',
                  conditionContent: '',
                  conditionIndex: 0,
                  operator: '',
                  subjectId: '',
                },
              ],
              moduleIndex: 0,
            },
          ],
        })
      }
      this.childList = this.list[this.activeItem]
    },
    reset: function () {
      // 重置
      this.curModule.name = ''
      this.curModule.permissions = 'team'
      this.curModule.team_ids = this.$store.state.shift.team_id
      this.curModule.invisible = '1'
      this.curModule.sort = ''
      this.curModule.color = '#c17dfb'
      this.activeItem = 0
      let listReset = [
        {
          questionId: '',
          name: '',
          moduleIndex: 0,
          questions: [],
          associatOperator: '与',
          moduleQueryList: [
            {
              associatOperator: '或',
              conditionList: [
                {
                  associatOperator: '或',
                  conditionContent: '',
                  conditionIndex: 0,
                  operator: '',
                  subjectId: '',
                },
              ],
              moduleIndex: 0,
            },
          ],
        },
        {
          name: '',
        },
      ]
      this.list = listReset
      this.childList = this.list[0]
    },

    onDelete: function (index) {
      if (this.list.length == 2) {
        this.$Message.warning('已经到第一个了')
        return
      }
      this.list.splice(index, 1)
      this.activeItem = this.list.length - 2
      this.childList = this.list[this.activeItem]
      console.log('shanchu', this.activeItem)
    },
    childData(data) {
      this.list[this.activeItem] = {
        questionId: '',
        name: '',
        moduleIndex: 0,
        questions: [],
        associatOperator: '与',
        moduleQueryList: [
          {
            associatOperator: '或',
            conditionList: [
              {
                associatOperator: '或',
                conditionContent: '',
                conditionIndex: 0,
                operator: '',
                subjectId: '',
              },
            ],
            moduleIndex: 0,
          },
        ],
      }
      this.childList = this.list[this.activeItem]
    },
    saveRule: function (formName) {
      // let lists = this.list.filter((l, i) => i !== this.list.length - 1)
      let lists = JSON.parse(JSON.stringify(this.list))
      lists.pop()
      if (!lists[0].questionId) {
        this.$Message.warning('请选择问卷条件')
        return
      }
      let flag = false
      lists.forEach(function (v, index) {
        v.moduleQueryList.forEach(function (m, inx) {
          m.conditionList.forEach(function (j, inx) {
            if (j.subjectId == '') {
              flag = true
            }

            if (typeof j['subjectId'] == 'object') {
              j['subjectId'] = j['subjectId'].join('||')
            }

            if (j.hasOwnProperty('multipleType')) {
              delete j.multipleType
            }
            if (j.hasOwnProperty('mulity')) {
              delete j.mulity
            }
            if (j.hasOwnProperty('multiple')) {
              delete j.multiple
            }
            if (j.hasOwnProperty('options')) {
              delete j.options
            }
            if (j.hasOwnProperty('digital')) {
              delete j.digital
            }
            if (j.hasOwnProperty('single_options')) {
              delete j.single_options
            }
            if (j['conditionContent'] && typeof j.conditionContent == 'object') {
                 j['conditionContent'] = j['conditionContent'].join('||')
            }
            if (j['betweenShip']) {
              j.conditionContent =
                j.conditionContent1 + '||' + j.conditionContent2
            }
          })
        })
      })
      if (flag) {
        this.$Message.warning('请选择问卷条件')
        return
      }
      let obj = {
        name: this.curModule.name,
        type: this.type,
        permissions: this.curModule.permissions,
        team_ids:
          this.curModule.permissions == 'team' ? this.curModule.team_ids : [],
        sort: this.curModule.sort,
        invisible: this.curModule.invisible,
        color: this.curModule.color,
        template: {
          templateName: this.curModule.name,
          moduleQueryList: lists,
        },
      }
      // console.log(obj)
      if (this.info) {
        obj.id = this.info.id
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addGroup(obj).then((res) => {
            if (res.code === 0) {
              console.log(res)
              if (this.info) {
                this.$Message.success('修改成功')
              } else {
                this.$Message.success('保存成功')
              }
              if (
                this.$store.state.allSelectedKeys.find(
                  (s) => s.key === 'confirmedGroup'
                )
              ) {
                this.refesh()
              }
              this.$store.commit('setAllSelectedKeys', {
                type: 'add',
                name: 'confirmedGroup',
                title: route['confirmedGroup'].title,
                key: `confirmedGroup`,
                extra: {},
              })
            } else {
              // debugger
              this.$Message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    },
    update: function () {
      this.$forceUpdate()
    },
  },
  created() {
    // 编辑
    if (this.info) {
      this.curModule = this.info
      this.curModule.invisible = this.curModule.invisible.toString()
      if (!this.colorList.includes(this.info.color)) {
        this.colorList.push(this.info.color)
      }
      this.curModule.color = this.info.color
      let list = JSON.parse(JSON.stringify(this.info.template.moduleQueryList))
      if (list.length > 0) {
        list.push({
          name: '',
        })
      } else {
        list = this.list
      }
      this.list = list
      this.childList = this.list[0]
      this.edit = true
    } else {
      // 非编辑状态第一个默认
      this.childList = this.list[0]
      this.edit = false
    }
  },
  mounted() {
    let teamList = this.$store.getters.curTeamList
    this.teamList = teamList
  },
}
</script>

<style lang="less" scoped>
.filterAnalysis {
  .ivu-form-item {
    display: inline-block;
    width: 33%;
    .el-cascader {
      .el-input input {
        line-height: 32px;
        height: 32px;
      }
    }
    .el-input input {
      line-height: 32px;
      height: 32px;
    }
  }

  .ivu-tabs-bar {
    margin-bottom: 0;
  }
  .report_t {
    i {
      width: 5px;
      height: 13px;
      background: #ffa615;
      border-radius: 5px;
      display: inline-block;
      margin-right: 6px;
    }
    &::after {
      content: '';
      display: block;
      clear: both;
    }
  }
  .card {
    background: #fff;
    padding: 20px 10px;
  }
  .patient-analysis {
    position: relative;
    overflow: hidden;
    height: 100%;
    display: flex;
    .right {
      flex: 1;
    }
  }
  .out-container__short {
    margin-left: 5px !important;
    transition: all 0.5s;
  }
  .out-container {
    margin-left: 100px;
    transition: all 0.5s;
    // background-color: #f9f6ff;
    padding: 10px 15px;
    border: solid 1px #e3e3e3;
    height: 70px;
    width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    & + .out-container {
      border-top: none;
    }
    &__active {
      border: 1px solid #2d8cf0 !important;
      border-right: none;
      background: #f6f9ff;
      position: relative;
    }
    &-line {
      position: relative;
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: -60px;
        width: 60px;
        border-bottom: solid 1.5px #e0e0e0;
        margin-top: -0.5px;
      }

      &:before {
        content: '';
        position: absolute;
        left: -60px;
        top: 50%;
        bottom: -1000px;
        border-left: solid 1.5px #e0e0e0;
      }
    }
    .out-container-body {
      .add-item {
        color: #2d8cf0;
      }
      .out-container-title {
        display: flex;
        span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 151px;
          text-align: center;
        }
        i {
          flex: 1;
        }
      }
    }
    .out-container-context {
      &::after {
        content: '';
        position: absolute;
        top: 0px;
        right: -3px;
        width: 5px;
        height: 68px;
        background: #f6f9ff;
        z-index: 999;
      }
    }
    .out-container-cover {
      position: absolute;
      top: 50%;
      left: -60px;
      width: 5px;
      height: 1000px;
      background-color: #fff;
      margin-top: 1px;
    }
    .out-relationship-select {
      position: absolute;
      left: -90px;
      top: 50%;
      margin-top: 20px;
    }
  }
}
</style>
